import {AfterViewInit, Component, ElementRef, HostListener, inject, Input, ViewChild} from '@angular/core';
import {BaseComponent} from "../../../BaseComponent";
import {UserMetricInstance} from "../../../../models/user/Metric/UserMetricInstance";
import {DatePipe} from "@angular/common";
import {DashboardService} from "../../../../services/dashboard/dashboard.service";
import {DataTypeGroupEnum} from "../../../../enums/dashboard/DataTypeUnitEnum";

@Component({
  selector: 'app-main-measure-card',
  templateUrl: './main-measure-card.component.html',
  styleUrls: ['./main-measure-card.component.css', '../measure-cards.component.css']
})
export class MainMeasureCardComponent extends BaseComponent implements AfterViewInit {

  @Input() card!: UserMetricInstance;

  @ViewChild('textContainer') textContainer: ElementRef | undefined;

  @ViewChild('cardContainer') cardContainer: ElementRef | undefined;

  protected widthRatio: number = 2.5;
  /**
   * Pipe used to translate timestamps in string dates
   * @protected
   */
  protected datePipe: DatePipe = inject(DatePipe);
  protected dashboardService: DashboardService = inject(DashboardService);
  protected readonly DataTypeGroupEnum = DataTypeGroupEnum;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.adjustFontSize();
  }

  ngAfterViewInit() {
    this.adjustFontSize();
  }

  calculatePercentageValue(lastValue: any, minVal: number, maxVal: number) {
    return (lastValue - minVal) / (maxVal - minVal) * 100
  }

  adjustFontSize() {
    const textContainer = this.textContainer?.nativeElement;
    const cardContainer = this.cardContainer?.nativeElement;
    if (textContainer && cardContainer) {
      if (textContainer.offsetWidth > cardContainer.offsetWidth) {
        this.widthRatio = this.widthRatio - 0.02;
      } else if (cardContainer.offsetWidth > textContainer.offsetWidth + 10) {
        this.widthRatio = this.widthRatio + 0.02;
      }
    }
    this.widthRatio = Math.min(2.5, Math.max(1, this.widthRatio));
    return this.widthRatio;
  }
}
